import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { APP_ROUTES } from '@/config/routes'
import { useAuthStore } from '@/app/store/auth.store'
import { useBreadcrumbs } from './useBreadcrumbs'
import { buildAvartarByString } from '@/utils/fomart'

// Shared state for Header visibility (Module scope)
const isHeaderVisible = ref(true)
const isHeaderSpaceOccupied = ref(true)
let lastScrollY = 0

export function useHeader() {
  const router = useRouter()
  const authStore = useAuthStore()
  const { breadcrumbs } = useBreadcrumbs()

  const search = ref('')

  const handleSearch = () => {
    if (!search.value.trim()) return
    console.log('Searching for:', search.value)
  }

  const userInitials = computed(() =>
    buildAvartarByString(authStore.user?.fullName)
  )

  const goToProfile = () => {
    router.push({ name: APP_ROUTES.PROFILE?.name })
  }

  // Handle scroll events from the <main> element
  const handleHeaderScroll = (e: Event) => {
    const target = e.target as HTMLElement
    const currentScrollY = target.scrollTop
    const maxScroll = target.scrollHeight - target.clientHeight

    // Show if at top (always occupy space at top)
    if (currentScrollY < 10) {
      isHeaderVisible.value = true
      isHeaderSpaceOccupied.value = true
      lastScrollY = currentScrollY
      return
    }

    // Scroll delta threshold to prevent jitter (15px)
    const delta = currentScrollY - lastScrollY
    if (Math.abs(delta) < 15) return

    // Near-bottom guard: If very close to bottom, don't show on small upward bounces
    const isNearBottom = currentScrollY >= maxScroll - 100
    
    // Hide on scroll down, show on scroll up
    if (delta > 0 && currentScrollY > 100) {
      isHeaderVisible.value = false
      isHeaderSpaceOccupied.value = false
    } else if (delta < 0 && !isNearBottom) {
      isHeaderVisible.value = true
      isHeaderSpaceOccupied.value = true
    }

    lastScrollY = currentScrollY
  }

  const setHeaderVisibility = (visible: boolean, occupySpace: boolean = false) => {
    isHeaderVisible.value = visible
    // Only change space occupation if explicitly requested or when hiding
    if (!visible) {
      isHeaderSpaceOccupied.value = false
    } else if (occupySpace) {
      isHeaderSpaceOccupied.value = true
    }
  }

  return {
    search,
    breadcrumbs,
    handleSearch,
    userInitials,
    goToProfile,
    isHeaderVisible,
    isHeaderSpaceOccupied,
    handleHeaderScroll,
    setHeaderVisibility,
    profileRouteName: APP_ROUTES.PROFILE?.name
  }
}